import { render } from "./Employes.vue?vue&type=template&id=d4263096&scoped=true"
import script from "./Employes.vue?vue&type=script&lang=js"
export * from "./Employes.vue?vue&type=script&lang=js"

import "./Employes.vue?vue&type=style&index=0&id=d4263096&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4263096"]])

export default __exports__